import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bubble",
  "use": "icon-bubble-usage",
  "viewBox": "0 0 178 57",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 178 57\" id=\"icon-bubble\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M149.5 0C165.24 0 178 12.76 178 28.5S165.24 57 149.5 57h-114C21.257 57 9.455 46.552 7.338 32.903L0 28.5l7.338-4.403C9.455 10.447 21.258 0 35.5 0h114Z\" fill=\"#FFEE9A\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol